import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const BasicInfoIcon3 = (props: SvgProps) => (
  <Svg
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <Path
      fill="#C0A46F"
      fillRule="evenodd"
      d="M17.79.75C15.72 8.09 8.09 12.362.75 10.292l-.002-.001v.002H.75c7.34 2.07 11.612 9.698 9.543 17.038h.002c2.056-7.289 9.594-11.553 16.888-9.584C19.934 15.616 15.734 8.041 17.79.751V.75Z"
      clipRule="evenodd"
    />
  </Svg>
)
export default BasicInfoIcon3
